import { defineComponent as _defineComponent } from 'vue'
import store from "@/store";
  import { useIsDesktop } from "@/features/useIsDesktop";

  import { computed } from "vue";
  
export default /*@__PURE__*/_defineComponent({
  __name: 'QuoteRequestCounter',
  emits: ["onRequestQuotes"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const emits = __emit;

  const { isDesktop } = useIsDesktop(990);

  const requestQuoteCounter = computed(() => {
    return store.state.builder.userSelectionDesign.length;
  });

const __returned__ = { emits, isDesktop, requestQuoteCounter, get store() { return store }, get useIsDesktop() { return useIsDesktop }, computed }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})